$(function(){
  onloadShowDescTab();

  //cartJsEvent();
  masterPromo(false);
  document.addEventListener('cart:updated', function(evt) {
    masterPromo(false);
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    setTimeout(function(){
      if ($('.cart__items[data-count="0"]').length > 0) {
        location.reload();
      }
    },1000);
  });
  document.addEventListener('ajaxProduct:added', function(evt) {
    masterPromo(false);
  });

  initflickityShopIndividual();
  initflickityRecommendation();
  initflickityHalfBannercollection();
  updateWidgetPosition();
  pdpReduceBottomPadding();
  onloadReadmore();
});

cartJsEvent = () =>{
  $(document).on('cart.requestStarted', function(event, cart) {
     var $html = `<div class="jsc-page-loading">
                  <div class="jsc-display-text">Updating Your Cart!</div>
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
     $('body').prepend($html);
   });
  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-page-loading').remove();
  });
}
masterPromo = (isDrawer) =>{
  setTimeout(function(){
    cartGift();
  },1000);
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          /*
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
          */
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          /*
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
          */
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

onloadShowDescTab = () => {

  if ($('input.accordion_checkbox').prop('checked') == true) {
    $('.parent-accordion.active .jsc-tab-content').show();
  }
}
showDescTab = (e) =>{

  // $('.jsc-minus').hide();
  // $(e).find('.jsc-plus').show();
    if ($(e).find('input').prop('checked') == true) {
      // console.log($(e));
      $(e).parents('.parent-accordion').addClass('active');
      $('.parent-accordion.active .jsc-tab-content').show();
      $(e).find('.jsc-minus').show();
      $(e).find('.jsc-plus').hide();
    }
    else {
      // console.log('unchecked');
      $(e).parents('.parent-accordion').removeClass('active');
      $(e).parents('.parent-accordion').addClass('inactive');
      $(e).parents('.parent-accordion').find('.jsc-tab-content').hide();
      $(e).find('.jsc-minus').hide();
      $(e).find('.jsc-plus').show();
    }

}

//start: grid ADD TO BAG
jscATB = (e) => {
  var $this = $(e);
  var $siblingThis = $this.siblings('.jsc-data-var-atb');
  var $varTitle = $siblingThis.attr('data-var-title');
  var $varID = $siblingThis.attr('data-var-id');
  //console.log($varTitle,$varID);
  cartJSAddQuery($varID, 1, {});

  var pageUrl = window.location.href;
  if (pageUrl.includes('cart')) {

    setTimeout(function() {
      location.reload();
    },1000);
  }
  else {
    $('#CartDrawer').parents('.js').addClass('js-drawer-open lock-scroll');
    $('#CartDrawer').addClass('is-transitioning').attr('tabindex','-1');
    setTimeout(function() {
      $('#CartDrawer').removeClass('is-transitioning');
      $('#CartDrawer').addClass('drawer--is-open');
    },400);
  }

}

jscCloseCartdrawer = (e) => {
  var $this = $(e);
  $this.parents('.drawer--right').removeClass('drawer--is-open js-drawer-open');
  $this.parents('.js').removeClass('js-drawer-open lock-scroll');
}

// For collection page with boost
jscVarSelected = (e,varTitle,varID,varPriceFormatted,varAvail,varImage,varComparePrice,varPrice) => {
  var $this = $(e);
  console.log($this);
  var $parentThis = $this.parents('.jsc-grid-variants').siblings('.jsc-data-var-atb');
  var $atbButton = $this.parents('.jsc-grid-variants').siblings('.jsc-grid-atb-style');
  var $varTitle = $parentThis.attr('data-var-title',varTitle);
  var $varID = $parentThis.attr('data-var-id',varID);
  var $varAvail = $parentThis.attr('data-var-avail',varAvail);
  var $productImageThis = $this.parents('.grid-product__content').find('.grid-product__image').attr('srcset',varImage);
  console.log($this.closest('.grid-product__content').find('.discount-perc'));
  var $discountPercText = $this.closest('.grid-product__content').find('.discount-perc');

  varPrice = parseInt(varPrice);
  varComparePrice = parseInt(varComparePrice);

  $this.siblings().removeClass('jsc-selected');
  $this.addClass('jsc-selected');

  $atbButton.find('.jsc-grid-price').html(varPriceFormatted);


  if (varAvail == 'false') {
    $atbButton.addClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.removeAttr('onclick','jscATB(this)');
    // $atbButton.attr('id','BIS_trigger');
    $atbButton.find('.jsc-grid-btn-title').html('Notify Me');
    $atbButton.find('.jsc-grid-btn-title').addClass('BIS_trigger jsc-grid-notifyme');
  }
  else {
    $atbButton.removeClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.attr('onclick','jscATB(this)');
    // $atbButton.removeAttr('id','BIS_trigger');
    $atbButton.find('.jsc-grid-btn-title').html('Add to bag');
    $atbButton.find('.jsc-grid-btn-title').removeClass('BIS_trigger jsc-grid-notifyme');
  }

  console.log('price',varPrice);
  console.log('compare at price',varComparePrice);
  if (varComparePrice > 0) {
    $atbButton.find('.jsc-grid-price').addClass('jsc-grid-discount-price');
    var itemScLabelBR = '';
    itemScLabelBR += '<div class="grid-product-label-bottom-right">';
    var savePrice = '';
    savePrice = Math.round((varComparePrice - varPrice) * 100 / varComparePrice);
    console.log(savePrice);
    savePrice += '% off';

    //console.log(boostPFSConfig);

    if (boostPFSConfig === undefined) {
      console.log("boostPFSConfig undefined");
    }

    if (boostPFSConfig) {
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemScLabelBR += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
      itemScLabelBR += '</div>';
      $discountPercText[0].innerHTML = itemScLabelBR;
    } else{
      console.log("boostPFSConfig not defined");
    }
    
    
    //itemHtml = itemHtml.replace(/{{itemScLabelBR}}/g, itemScLabelBR);    
  } else {
    $atbButton.find('.jsc-grid-discount-price').removeClass('jsc-grid-discount-price');
    console.log($discountPercText[0]);
    $discountPercText[0].innerHTML = '';
  }
}

// For no boost pages
jscVarSelected2 = (e,varTitle,varID,varPriceFormatted,varAvail,varImage,varComparePrice,varPrice) => {
  var $this = $(e);
  console.log($this);
  var $parentThis = $this.parents('.jsc-grid-variants').siblings('.jsc-data-var-atb');
  var $atbButton = $this.parents('.jsc-grid-variants').siblings('.jsc-grid-atb-style');
  var $varTitle = $parentThis.attr('data-var-title',varTitle);
  var $varID = $parentThis.attr('data-var-id',varID);
  var $varAvail = $parentThis.attr('data-var-avail',varAvail);
  var $productImageThis = $this.parents('.grid-product__content').find('.grid-product__image').attr('srcset',varImage);
  console.log($this.closest('.grid-product__content').find('.discount-perc'));
  var $discountPercText = $this.closest('.grid-product__content').find('.discount-perc');

  varPrice = parseInt(varPrice);
  varComparePrice = parseInt(varComparePrice);

  $this.siblings().removeClass('jsc-selected');
  $this.addClass('jsc-selected');

  $atbButton.find('.jsc-grid-price').html(varPriceFormatted);


  if (varAvail == 'false') {
    $atbButton.addClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.removeAttr('onclick','jscATB(this)');
    // $atbButton.attr('id','BIS_trigger');
    $atbButton.find('.jsc-grid-btn-title').html('Notify Me');
    $atbButton.find('.jsc-grid-btn-title').addClass('BIS_trigger jsc-grid-notifyme');
  }
  else {
    $atbButton.removeClass('BIS_trigger jsc-grid-notifyme');
    $atbButton.attr('onclick','jscATB(this)');
    // $atbButton.removeAttr('id','BIS_trigger');
    $atbButton.find('.jsc-grid-btn-title').html('Add to bag');
    $atbButton.find('.jsc-grid-btn-title').removeClass('BIS_trigger jsc-grid-notifyme');
  }

  console.log('price',varPrice);
  console.log('compare at price',varComparePrice);
  if (varComparePrice > 0) {
    $atbButton.find('.jsc-grid-price').addClass('jsc-grid-discount-price');
    var itemScLabelBR = '';
    itemScLabelBR += '<div class="grid-product-label-bottom-right">';
    var savePrice = '';
    savePrice = Math.round((varComparePrice - varPrice) * 100 / varComparePrice);
    console.log(savePrice);
    savePrice += '% off';
  
    var savePriceText = '<span class="grid-product__price--savings">'+savePrice+'</div>';
    itemScLabelBR += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    itemScLabelBR += '</div>';
    $discountPercText[0].innerHTML = itemScLabelBR;
     
  } else {
    $atbButton.find('.jsc-grid-discount-price').removeClass('jsc-grid-discount-price');
    console.log($discountPercText[0]);
    $discountPercText[0].innerHTML = '';
  }
}

//end: grid ADD TO BAG

//start: gwp
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('#jsc-cart-gift');
  var $vid = $elem.val();
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');
  var removeGift = sessionStorage.getItem("FreeGift");

  //console.log($vid);

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0 ) {
    if (removeGift != 'Remove') {
      cartJSAddQuery($vid,1,$obj,true);
    }

  }

}

removeCartGift = () =>{
  var $elem = $('#jsc-cart-gift-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
}

removeFreeGift = (e,varID) =>{
    sessionStorage.setItem("FreeGift", "Remove");
    // var varID = $('#jsc-cart-gift').val();
    var varID = varID;
    //console.log(varID);
    cartJSUpdateQuery(varID, 0);
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
   });
  }
//end: gwp

//start: initiate the carousel of pdp shop_them_individually section
initflickityShopIndividual = () => {
  var timesRun = 0;
  var countGrid = 0;
    var timer = setInterval(function() {

      if ($(window).width() > 1025) {
        if ($('.jsc-shop-individual-flickity').length > 0 ) {

            $('.jsc-shop-individual-flickity .jsc-grid__item').each(function() {
              countGrid += 1;
              // console.log(countGrid,'in loop');
            });
            // console.log(countGrid);
            if (countGrid > 4) {
              var flkty = new Flickity( '.jsc-shop-individual-flickity' , {
                // options
                cellAlign: 'center',
                contain: false,
                pageDots: false,
                groupCells: true,
                wrapAround: true,
                draggable: true,
                prevNextButtons: false,
                //autoPlay: 5000,
                on: {
                  ready: function() {
                    $(this.element).addClass('jsc-flickity-initiated');
                  }
                }
              });
            }
            else {
              $('.jsc-shop-individual-flickity').addClass('jsc-shop-individual-flex');
            }

          }


          clearInterval(timer);
        }
      if (($(window).width() > 799) && ($(window).width() < 1024)) {
        if ($('.jsc-shop-individual-flickity').length > 0 ) {

            $('.jsc-shop-individual-flickity .jsc-grid__item').each(function() {
              countGrid += 1;
              // console.log(countGrid,'in loop');
            });
            // console.log(countGrid);
            if (countGrid > 3) {
              var flkty = new Flickity( '.jsc-shop-individual-flickity' , {
                // options
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                groupCells: true,
                wrapAround: false,
                draggable: true,
                prevNextButtons: false,
                //autoPlay: 5000,
                on: {
                  ready: function() {
                    $(this.element).addClass('jsc-flickity-initiated');
                  }
                }
              });
            }
            else {
              $('.jsc-shop-individual-flickity').addClass('jsc-shop-individual-flex');
            }

          }


          clearInterval(timer);
      }
    }, 800);

}
//end: initiate the carousel of pdp shop_them_individually section

//start: initiate the carousel of pdp recommendations section
initflickityRecommendation = () => {
  var timesRun = 0;
  var countGrid = 0;
    var timer = setInterval(function() {

      if (($(window).width() > 799) && ($(window).width() < 1025)) {
        if ($('.jsc-recommendation-flickity').length > 0 ) {

            $('.jsc-recommendation-flickity .jsc-grid__item').each(function() {
              countGrid += 1;
              // console.log(countGrid,'in loop');
            });
            // console.log(countGrid);
            if (countGrid > 3) {
              if ($('.jsc-feat-col-flex').length > 0) {
                $('.jsc-recommendation-flickity').removeClass('jsc-feat-col-flex');
              }

              var flkty = new Flickity( '.jsc-recommendation-flickity' , {
                // options
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                groupCells: true,
                wrapAround: false,
                draggable: true,
                prevNextButtons: false,
                //autoPlay: 5000,
                on: {
                  ready: function() {
                    $(this.element).addClass('jsc-flickity-initiated');
                  }
                }
              });

            }
            else {
              $('.jsc-recommendation-flickity').addClass('jsc-shop-individual-flex');
            }

          }

          // clearInterval(timer);
      }

    }, 800);

}
//end: initiate the carousel of pdp recommendations section

//start: initiate the carousel of homepage half banner collection section
initflickityHalfBannercollection = () => {

  var galleryElems = document.querySelectorAll('.jsc-half-bannerColl-flickity');
  var timesRun = 0;
  var countGrid = 0;
    var timer = setInterval(function() {

      if ($(window).width() > 1025) {}
        if ($('.jsc-half-bannerColl-flickity').length > 0 ) {

            $('.jsc-half-bannerColl-flickity .jsc-grid__item').each(function() {
              countGrid += 1;
              // console.log(countGrid,'in loop');
            });
            // console.log(countGrid);
            if (countGrid > 2) {
              // var flkty = new Flickity( '.jsc-half-bannerColl-flickity' , {
              //   // options
              //   cellAlign: 'center',
              //   contain: false,
              //   pageDots: false,
              //   groupCells: true,
              //   wrapAround: false,
              //   draggable: true,
              //   prevNextButtons: true,
              //   //autoPlay: 5000,
              //   on: {
              //     ready: function() {
              //       $(this.element).addClass('jsc-flickity-initiated');
              //     }
              //   }
              // });
              for ( var i=0, len = galleryElems.length; i < len; i++ ) {
                var galleryElem = galleryElems[i];

                new Flickity( galleryElem, {

                    cellAlign: 'center',
                    contain: false,
                    pageDots: false,
                    groupCells: true,
                    wrapAround: true,
                    draggable: true,
                    prevNextButtons: true,
                    autoPlay: false,
                    setGallerySize: true,
                    on: {
                      ready: function() {
                        $(this.element).addClass('jsc-flickity-initiated');
                      }
                    }
                });
              }
            }
            else {
              // $('.jsc-shop-individual-flickity').addClass('jsc-shop-individual-flex');
            }

            setTimeout(function(){
              $('.jsc-half-bannerColl-flickity .jsc-grid__item').css("height","100%");


            },1500);

          }


          clearInterval(timer);


    }, 800);

}
//end: initiate the carousel of homepage half banner collection section

showAccountdropdown = () => {
  $('.jsc-account-dropdown-div').show();
}
hideAccountdropdown = () => {
  $('.jsc-account-dropdown-div').hide();
}

updateWidgetPosition = () => {

  // setTimeout(function(){
  //   //console.log($('#smile-ui-container').length);
  //   if ($('#smile-ui-container').length > 0) {
  //     $('#smile-ui-container').attr('style', ['z-index: 0 !important;position:fixed']);
  //   }
  // },2500);

  var timer = setInterval(function() {
    console.log($('#smile-ui-container').length);
    if ($('#smile-ui-container').length > 0) {
      $('#smile-ui-container').attr('style', ['z-index: 28 !important;position:fixed']);
      clearInterval(timer);
    }
  }, 500);

  setTimeout(function(){
    if ($('.eGvvXF').length > 0) {
      $('.eGvvXF').attr('style', ['z-index: 0 !important;position:fixed']);
    }
  },2000);

}

jscUpdatePrice = (varTitle) => {
  //console.log(varTitle);
  $('.jsc-mobile-product-price').each(function() {
    var $this = $(this);
    var $thisPrice = $this.attr('data-price');
    var $thisTitle = $this.attr('data-title');
    var $thisComparePrice = $this.attr('data-compare-price');
    var $thisSaveAmount = $this.attr('data-saved');

    //console.log($thisSaveAmount);

    if ($thisTitle == varTitle) {
      //console.log($thisPrice);
      $('.jsc-variantAndPriceTablet .product__price').find('span').html($thisPrice);
      $('.jsc-variantAndPriceTablet .product__price.product__price--compare').find('span').html($thisComparePrice);
      $('.jsc-variantAndPriceTablet .product__price-savings').find('span').html($thisSaveAmount);

      //price on top of mobile image
      $('.jsc-pdp-tablet-down .product__price').find('span').html($thisPrice);
      $('.jsc-pdp-tablet-down .product__price.product__price--compare').find('span').html($thisComparePrice);

      //price under product title for desktop
      $('.jsc-priceAndRatings .product__price.product__price--compare').find('span').html($thisComparePrice);

      if ( $thisComparePrice != '' ) {
        $('.jsc-discount-badge').show();
      }
      else{
        $('.jsc-discount-badge').hide();
      }
    }

  })
}

pdpReduceBottomPadding = () => {

  if ($('.jsc-reduce-bp').length > 0) {
    $('.jsc-reduce-bp').parent().addClass('jsc-reduce-bp-parent');
  }
}

togglePlusMinusIcon = (e) => {
  setTimeout(function() {
    var $this = $(e);
    var $thisOpen = $this.parent().find('.is-open');

    if ($thisOpen.length > 0) {
      $thisOpen.find('.jsc-plusMinus-icon .jsc-minus').show();
      $thisOpen.find('.jsc-plusMinus-icon .jsc-plus').hide();
    }
    else {
      $this.find('.jsc-plusMinus-icon .jsc-minus').hide();
      $this.find('.jsc-plusMinus-icon .jsc-plus').show();
    }
  },200);

}

//START: accordion READ MORE
onloadReadmore = () => {
  //length in characters
    var maxLength = 250;
    var ellipsestext = "...";
    var moretext = "Read more";
    var lesstext = "Read less";
    $(".show-read-more").each(function(){
        //get the text of paragraph or div
        var myStr = $(this).text();

      console.log(myStr);
      console.log($(this).html());

       // check if it exceeds the maxLength limit
        if($.trim(myStr).length > maxLength){
            //get only limited string firts to show text on page load
            var newStr = myStr.substring(0, maxLength);

            //get remaining string
            var removedStr = myStr.substr(maxLength);
            // original code but it cuts of some of the text     var removedStr = myStr.substr(maxLength, $.trim(myStr).length - maxLength);
            // now append the newStr + "..."+ hidden remaining string
            var Newhtml = newStr + '<span class="moreellipses">' + ellipsestext+ '</span><span class="morecontent"><span>' + removedStr + '</span>&nbsp;&nbsp;<a href="javascript:void(0)" class="ReadMore">' + moretext + '</a></span>';
            //
            $(this).html(Newhtml);
        }
    });

    //function to show/hide remaining text on ReadMore button click
    $(".ReadMore").click(function(){

        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        }
         else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }

        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
}
//END: accordion READ MORE

//START: discount badge
discountBadge = () => {
  setTimeout(function() {
    var $varId = $('.jsc-variant-list').find(':selected').val();
    var $varDisPerc = $('.jsc-variant-list').find(':selected').attr('data-discount-percent-off');
    var $varDisPrice = $('.jsc-variant-list').find(':selected').attr('data-discount-price-off');
    if ($varDisPerc) {
      $('.jsc-discount-off').text($varDisPerc + "% OFF");
      $('.jsc-discount-badge').show();
    }else{
      $('.jsc-discount-badge').hide();
    }
    if ($varDisPrice) {
      $('.jsc-price-off').text($varDisPrice + " OFF");
      $('.jsc-discount-badge').show();
    }else{
      $('.jsc-discount-badge').hide();
    }
  },10);
}
//END: discount badge
